import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';

function ProfileIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <svg
      {...svgProps}
      viewBox="3 -5 15 29"
    >
      <g fill="none" fillRule="evenodd" >
        <circle stroke={color} cx="11.5" cy="11.5" r="11.5" />
        <path
          d="M19.094 19.452c0-2.696-1.843-5-5.454-5H9.55c-3.612 0-5.456 2.304-5.456 5m7.5-6.333c2.26
            0 4.09-1.792 4.09-4 0-2.21-1.83-4-4.09-4s-4.09 1.79-4.09 4c0 2.208 1.83 4 4.09 4z"
          stroke={color}
        />
      </g>
    </svg>
  );
}

ProfileIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

ProfileIcon.defaultProps = {
  height: 21,
  width: 21,
};

export default pure(ProfileIcon);
